import { Routes } from '@angular/router';
import { Inicio } from './features/inicio/inicio';
import { Layout } from './core/layouts/layout/layout';
import { authGuard } from './core/auth/guards/auth.guard';
import { roleGuard } from './core/auth/guards/role.guard';
import { featureFlagGuard } from './core/feature-flags';
import { AuthCallbackPage } from './core/auth/pages/auth-callback.page';
import { AccessDeniedPage } from './core/auth/pages/access-denied.page';
import { NEXUS_OPERACIONAL_ACCESS_ROLES } from './core/auth/access-roles';
export const routes: Routes = [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'inicio',
    },
    // Rota de callback de autenticação (pública)
    {
        path: 'auth-callback',
        component: AuthCallbackPage,
    },
    // Rota de acesso negado (pública)
    {
        path: 'acesso-negado',
        component: AccessDeniedPage,
    },
    // Rota PUBLICA: Declaracao de Veracidade VD (acessada pela vitima via link WhatsApp/SMS)
    {
        path: 'declaracao-vd/:token',
        loadComponent: () =>
            import('./features/provid/declaracao-publica/declaracao-vd.page').then(m => m.DeclaracaoVDPage),
    },
    // Rotas protegidas
    {
        path: '',
        component: Layout,
        canActivate: [authGuard],
        children: [
            {
                path: 'inicio',
                component: Inicio,
            },
            {
                path: 'perfil',
                loadChildren: () =>
                    import('./features/perfil/perfil.routes').then(m => m.perfilRoutes),
            },
            {
                path: 'consultas',
                canActivate: [roleGuard],
                data: { roles: ['app.nexus.acesso'] },
                loadChildren: () =>
                    import('./features/consultas/consultas.routes').then(m => m.consultasRoutes),
            },
            {
                path: 'copom',
                canActivate: [roleGuard, featureFlagGuard],
                data: { roles: ['app.nexus.acesso'], featureFlag: 'copom' },
                loadChildren: () =>
                    import('./features/copom/copom.routes').then(m => m.copomRoutes),
            },
            {
                path: 'sentinela',
                canActivate: [roleGuard, featureFlagGuard],
                data: { roles: ['app.nexus.acesso', 'app.sentinela.acesso'], featureFlag: 'sentinela' },
                loadChildren: () =>
                    import('./features/sentinela/sentinela.routes').then(m => m.sentinelaRoutes),
            },
            {
                path: 'rap',
                canActivate: [roleGuard, featureFlagGuard],
                data: { roles: NEXUS_OPERACIONAL_ACCESS_ROLES, featureFlag: 'rap' },
                loadChildren: () =>
                    import('./features/rap/rap.routes').then(m => m.rapRoutes),
            },
            {
                path: 'viatura',
                canActivate: [roleGuard],
                data: { roles: ['app.nexus.acesso'] },
                loadChildren: () =>
                    import('./features/viatura/viatura.routes').then(m => m.viaturaRoutes),
            },
            {
                path: 'eleicoes',
                canActivate: [roleGuard, featureFlagGuard],
                data: { roles: NEXUS_OPERACIONAL_ACCESS_ROLES, featureFlag: 'eleicoesPosto' },
                loadChildren: () =>
                    import('./features/eleicoes/eleicoes.routes').then(m => m.eleicoesRoutes),
            },
            {
                path: 'tci',
                canActivate: [roleGuard, featureFlagGuard],
                data: { roles: NEXUS_OPERACIONAL_ACCESS_ROLES, featureFlag: 'tci' },
                loadChildren: () =>
                    import('./features/tci/tci.routes').then(m => m.tciRoutes),
            },
            {
                path: 'ordem-servico',
                canActivate: [roleGuard, featureFlagGuard],
                data: { roles: NEXUS_OPERACIONAL_ACCESS_ROLES, featureFlag: 'ordemServico' },
                loadChildren: () =>
                    import('./features/ordem-servico/ordem-servico.routes').then(
                        m => m.ordemServicoRoutes
                    ),
            },
            {
                path: 'provid',
                canActivate: [roleGuard, featureFlagGuard],
                data: { roles: NEXUS_OPERACIONAL_ACCESS_ROLES, featureFlag: 'provid' },
                loadChildren: () =>
                    import('./features/provid/provid.routes').then(m => m.providRoutes),
            },
            {
                path: 'coordenacao',
                canActivate: [roleGuard, featureFlagGuard],
                data: { roles: ['app.nexus.acesso'], featureFlag: 'coordenacaoOperacional' },
                loadChildren: () =>
                    import('./features/coordenacao/coordenacao.routes').then(m => m.coordenacaoRoutes),
            },
            {
                path: 'novidades',
                canActivate: [featureFlagGuard],
                data: { featureFlag: 'novidades' },
                loadChildren: () =>
                    import('./features/novidades/novidades.routes').then(m => m.novidadesRoutes),
            },
        ]
    },
    // fallback
    {
        path: '**',
        redirectTo: 'inicio',
    },
];
